import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	gap: var(--spacing-medium);
	min-width: 0;
	flex: 1;
`;
